import {AuthClient} from "./auth";
import {WebClient} from "./client";
import {Testimonial} from "../../models/site";
import {PasswordResetConfirm, PasswordResetRequest, PasswordResetValidate} from "../../models/user";

export async function PublicWebClient(endpoint: string, method = "GET", body: any | undefined = undefined) {
    const baseUrl = "https://api.pennypusher.net"

    let headers: HeadersInit = {
        "Content-Type": "application/json",
    };

    let config: RequestInit = {
        method: method,
        headers: headers,
    };

    if (body !== undefined) {
        config.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(encodeURI(baseUrl + endpoint), config);

        // Attempt to parse JSON response
        let data;
        try {
            data = await response.json();
        } catch {
            data = { error: "Invalid JSON response" };
        }

        if (!response.ok) {
            return {
                status: response.status,
                data: data || { error: response.statusText },
                url: response.url,
            };
        }

        return {
            status: response.status,
            data: data,
            url: response.url,
        };
    } catch (e: any) {
        return {
            status: 500,
            data: { error: e.message || "Network error" },
        };
    }
}

// ---------------------------------------- RESET PASSWORD ----------------------------------------
PublicWebClient.PasswordResetRequest = function (request: PasswordResetRequest) {
    return PublicWebClient(`/api/v1/user/password/reset/request/`, "POST", request);
}

PublicWebClient.PasswordResetValidate = function (request: PasswordResetValidate) {
    return PublicWebClient(`/api/v1/user/password/reset/validate/`, "POST", request);
}

PublicWebClient.PasswordResetConfirm = function (request: PasswordResetConfirm) {
    return PublicWebClient(`/api/v1/user/password/reset/confirm/`, "POST", request);
}

// ---------------------------------------- NEWSLETTER ----------------------------------------
PublicWebClient.GetPublishedNewsletterList = function (page: number){
    return PublicWebClient(`/api/v1/newsletter/?page=${page}`, "GET");
}

// ---------------------------------------- NEWSLETTER SUBSCRIBER ----------------------------------------
PublicWebClient.SubscribeToNewsletter = async function (email: string) {
    const body = {
        "email": email
    }
    return AuthClient("/api/v1/newsletter/subscribe/", "POST", body);
}

PublicWebClient.UnsubscribeNewsletter = function (email: string){
    const body = {
        "email": email
    }
    return AuthClient("/api/v1/newsletter/unsubscribe/", "PATCH", body);
}

// ---------------------------------------- TESTIMONIAL ----------------------------------------
PublicWebClient.GetPublicTestimonialsPaginated = function (page: number){
    return WebClient(`/api/v1/testimonial/?page=${page}`, "GET");
}

PublicWebClient.GetPublicTestimonial = function (testimonial: Testimonial){
    return WebClient(`/api/v1/testimonial/?id=${testimonial.id}`, "GET");
}
